import React from 'react';

const OtherSkills = () => {
    return (
        
           <div className="otherskills">
               <h3>Autres compétences</h3>
               <div className="list">
                   <ul>
                       <li><i className='fas fa-check-square'> Anglais courant</i></li>
                       <li><i className='fas fa-check-square'> Github</i></li>
                       <li><i className='fas fa-check-square'> SEO</i></li>
                       <li><i className='fas fa-check-square'> methodes agiles</i></li>
                   </ul>
                   <ul>
                       <li><i className='fas fa-check-square'> Figma</i></li>
                       <li><i className='fas fa-check-square'> Adobe XD</i></li>
                       <li><i className='fas fa-check-square'> Photoshop</i></li>
                       <li><i className='fas fa-check-square'> Blender</i></li>
                   </ul>
               </div>
           </div>
        
    );
};

export default OtherSkills;